<template>
    <div role="main" class="main edition">
        <div v-if="ready==false" class="loader">
            <div class="container">
                <div class="row">
                    <div class="col-sm-1 mx-md-auto text-center">
                        <spring-spinner
                        :animation-duration="3000"
                        :size="60"
                        color="#124191"
                        />
                    </div>
                </div>
            </div>
        </div>
        <div v-else>
            <div class="slider" v-html="editionInfo.media"></div>
            <div class="container">
                <div class="row">
                    <div class="col-sm-12 mx-md-auto text-center">
                        <h2>code::dive {{ $route.params.id }}</h2>
                    </div>
                </div>
                <div class="row">
                    <div class="description" v-html="editionInfo.description"></div>
                </div>
                <div class="row mt-3">
                    <div class="col-sm-12 mx-md-auto text-center">
                        <h2 class="font-weight-normal text-9 text-uppercase justify-center mb-3 pb-3 pt-2">List of lectures</h2>
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col-sm-12">
                        <ul class="lectures">
                            <li>
                                <span class="text-5 title">Lecture</span>
                                <span class="text-5 author">Speakers</span>
                            </li>
                            <li v-for="lecture in lectures" :key="lecture.id">
                              <template v-if="lecture.lectures_authors.length > 0">
                              <a :href="'/'+$route.params.id+'/'+lecture.slug" class="text-5 title">
                                {{ lecture.lecture_title }}
                              </a>
                              <span class="text-5 author">
                                    <a :href="'/speaker/'+author.authors.slug" v-for="author in lecture.lectures_authors" :key="author.id">
                                        {{ author.authors.name }}
                                    </a>
                                </span>
                              </template>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <Partners />
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import Partners from '@/components/Partners.vue'
import { SpringSpinner  } from 'epic-spinners'

export default {
    name: 'Edition',
    components: {
        Partners,
        SpringSpinner
    },
    props: ['info'],
    data(){
        return{
            id: '',
            editionInfo: '',
            lectures: '',
            authors: '',
            nav: '',
            lectures_id: '',
            filesTemp: '',
            myOptions: {

            },
            isActive: false,
            dropdown: false,
            defaultImage: 'http://testdivetest.nokiawroclaw.pl/api/directus/public/uploads/codedive/originals/e099e6d5-c9a4-4d2e-b440-0561f418f480.png',
            ready: false,
          log: console.log,
        }
    },
    methods: {
        showNav: function() {
            this.isActive = !this.isActive;
        },
        showDropDown: function() {
            this.dropdown = !this.dropdown;
        },
        getId(){
            axios.get(process.env.VUE_APP_BASE_URL+'/codedive/items/editions?filter[name]='+this.$route.params.id)
                .then(response => {
                    this.editionInfo = response.data.data[0];
                })
                .then(response => {
                    this.id = this.editionInfo.id;
                })
                .then(response => {
                    axios.get(process.env.VUE_APP_BASE_URL+'/codedive/items/lectures?filter[edition]='+this.id+'&fields=*.*')
                    .then(response => {
                        this.lectures = response.data.data;
                    })
                    .then(response => {
                        for(let i = 0; i < this.lectures.length;i++){
                            for(let j = 0; j < this.lectures[i].lectures_authors.length; j++){
                                this.lectures_id += this.lectures[i].lectures_authors[j].authors_id+ ',';
                            }
                        }
                        this.ready = true;
                    })
                    .then(response => {
                        axios.get(process.env.VUE_APP_BASE_URL+'/codedive/items/authors?fields=id,first_name,last_name,image,image_full_url,slug&filter[id][in]='+this.lectures_id+'&sort=image')
                        .then(response => {
                            this.authors = response.data.data;
                        })
                        .then(response => {
                            for(let i = 0; i < this.authors.length;i++){
                                this.filesTemp += this.authors[i].image+ ','
                            }
                        })
                        .then(response => {
                            axios.get(process.env.VUE_APP_BASE_URL+'/codedive/files?filter[id][in]='+this.filesTemp)
                                .then(response => {
                                    for(let i = 0; i < this.authors.length;i++){
                                        this.authors[i].image_full_url = response.data.data[i].data.full_url
                                    }
                                })
                        })
                        .then(response => {
                            for(let i = 0; i < this.lectures.length;i++){
                                for(let j = 0; j < this.lectures[i].lectures_authors.length; j++){
                                    let id = this.lectures[i].lectures_authors[j].authors_id;
                                    axios.get(process.env.VUE_APP_BASE_URL+'/codedive/items/authors?fields=id,first_name,last_name,slug&filter[id]='+id)
                                        .then(response => {
                                            this.lectures[i].lectures_authors[j].authors = {
                                              name: response.data.data[0].first_name + ' ' +response.data.data[0].last_name,
                                              slug: response.data.data[0].slug
                                            }
                                        })

                                }
                            }
                        })
                        .then(response => {
                            this.ready = true;
                        })
                    })

                })

        },
        slug: function(str) {
          if (str) {
            str = str.replace(/^\s+|\s+$/g, '-'); // trim
            str = str.toLowerCase();

            // remove accents, swap ñ for n, etc
            var from = "àáäâąèéëêęìíïîłńśźżòóöôùúüûñç·/_,:;ăț";
            var to   = "aaaaaeeeeeiiiilnszzoooouuuunc------at";
            for (var i=0, l=from.length ; i<l ; i++) {
              str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
            }

            str = str.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
                .replace(/\s+/g, '-') // collapse whitespace and replace by -
                .replace(/-+/g, '-'); // collapse dashes

            return str;
          }

        }
    },
    created(){
    },
    mounted(){
    },
    beforeMount(){
        this.getId();
    },
}
</script>

<style lang="scss">
    @import '@/assets/sass/variables.scss';
    @import '@/assets/sass/edition.scss';
</style>
